import React from 'react';

export function MessageAlert () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="110"
      height="142"
      fill="none"
      viewBox="0 0 110 142"
    >
      <rect
        width="110"
        height="90"
        fill="url(#paint0_linear_18964_28193)"
        rx="10"
      />
      <g
        stroke="#4FADA6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        clipPath="url(#clip0_18964_28193)"
      >
        <path d="M55 72.857c15.385 0 27.857-12.472 27.857-27.857S70.385 17.143 55 17.143 27.143 29.615 27.143 45 39.615 72.857 55 72.857z" />
        <path d="M46 45.666L51.538 51 64 39" />
      </g>
      <path
        fill="url(#paint1_linear_18964_28193)"
        d="M31 90h48l-21.172 21.172a4 4 0 01-5.656 0L31 90z"
      />
      <ellipse
        cx="55"
        cy="132"
        fill="url(#paint2_radial_18964_28193)"
        fillOpacity="0.3"
        rx="55"
        ry="10"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18964_28193"
          x1="110"
          x2="44.5"
          y1="37"
          y2="37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C5F5F2" />
          <stop offset="0.23" stopColor="#E4FBF9" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18964_28193"
          x1="55"
          x2="55"
          y1="90"
          y2="104.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D6F7F4" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_18964_28193"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(55 0 0 10 55 132)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#11514C" />
          <stop offset="1" stopColor="#11514C" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_18964_28193">
          <path
            fill="#fff"
            d="M0 0H60V60H0z"
            transform="translate(25 15)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
